(function(){
  function init(section){
    if(section.dataset.featuresReady)return;
    section.dataset.featuresReady='true';
    section.style.setProperty('--feature-fade-duration',(Number(section.dataset.fadeDuration)||900)+'ms');
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){if(entry.isIntersecting){section.classList.add('is-visible');observer.disconnect();}});
    },{threshold:.14});
    observer.observe(section);
    var images=Array.prototype.slice.call(section.querySelectorAll('[data-feature-image]'));
    if(images.length<2||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var index=0;
    var delay=Number(section.dataset.imageDelay)||5000;
    window.setInterval(function(){
      images[index].classList.remove('is-active');
      images[index].setAttribute('aria-hidden','true');
      index=(index+1)%images.length;
      images[index].classList.add('is-active');
      images[index].setAttribute('aria-hidden','false');
    },delay);
  }
  function boot(){document.querySelectorAll('[data-leile-features]').forEach(init);}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
  document.addEventListener('shopify:section:load',boot);
})();
